/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */

import { useCallback } from 'react';
import { connect } from 'react-redux';

import Button from 'components/form/Button.component';
import CurrencySign from 'components/price/CurrencySign.component';
import { DOWNLOAD_EXCEL } from 'constants/csv.const';
import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';
import asArray from 'utils/arrays/asArray.util';
import { exportCSV } from 'utils/converters/csv.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import currencySign from 'utils/intl/currencySign.util';
import C from 'utils/values/constant.util';

import { convertToMoneyAfterVat } from 'reports/utils';

import CN from './RevenueByServicesTable.module.scss';

const TABLE_HEADERS = C(['Service', 'Revenue', 'Count']);

const RevenueByServicesTable = ({ salesReport, startDate, endDate, currentSign }) => {
  const handleExportCsv = useCallback(() => {
    const csvData = asArray(salesReport.lastRequestResponse.service_group).map((service) => {
      const values = [
        service.name,
        currencySign({ value: service.total.toFixed(2), currentSalonAbbr: currentSign }),
        service.visits,
      ];

      return TABLE_HEADERS.reduce((acc, header, i) => {
        acc[header] = values[i];
        return acc;
      }, {});
    });

    exportCSV({ data: csvData, fileName: 'Revenue by services' });
  }, [currentSign, salesReport.lastRequestResponse.service_group]);

  const compareServicesByRevenue = (e1, e2) => (e1.total <= e2.total ? 1 : -1);

  const hasTableData = fromAnyToBool(salesReport.lastRequestResponse.service_group.length);

  return (
    <div id="revenue-by-services">
      <div className="t-bgr cfix">
        <div className="t-wrap">
          <div className={CN.tableHeader}>
            <h2>Revenue by services</h2>
            <Button onClick={handleExportCsv} disabled={!hasTableData} variant="primaryForce" width="small" height="xs">
              <span className={CN.buttonFont}>{DOWNLOAD_EXCEL}</span>
            </Button>
          </div>
          <div className="date-in-tbl-for-export">
            From <strong>{startDate}</strong> to <strong>{endDate}</strong>
          </div>
          <table className="table-reports" id="table-to-xls-revenue-by-services">
            <thead>
              <tr>
                <th className="item-name">{TABLE_HEADERS[0]}</th>
                <th>{TABLE_HEADERS[1]}</th>
                <th>{TABLE_HEADERS[2]}</th>
                <th className="empty-cell" />
              </tr>
            </thead>

            <tbody>
              {salesReport.lastRequestResponse &&
                salesReport.lastRequestResponse.service_group.sort(compareServicesByRevenue).map((sGroup) => (
                  <tr>
                    <td>{sGroup.name}</td>
                    <td>
                      <CurrencySign />
                      {`${convertToMoneyAfterVat(sGroup.total).toFixed(2)}`}
                    </td>
                    <td>{sGroup.visits}</td>
                    <td />
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  const { reports } = state;
  const { salesReport } = reports;
  return {
    salesReport,
    currentSign: selectCurrentSalonCurrency(state),
  };
}

export default connect(mapStateToProps, null)(RevenueByServicesTable);
